import PageWrapper from "../../components/common/PageWrapper";
import Header from "../../components/common/Header";
import BodyWrapper from "../../components/common/BodyWrapper";
import Footer from "../../components/common/Footer";
import Wrapper from "../../components/dashboard/dashboardPartials/Wrapper";
import MySubscriptions from "../../components/dashboard/dashboardPartials/MySubscriptions";
import MyOrders from "../../components/dashboard/dashboardPartials/MyOrders";
import AllProfileOptions from "../../components/dashboard/profilePartials/AllProfileOptions";
import EditPersonalInfo from "../../components/dashboard/profilePartials/EditPersonalInfo";
import PaymentCards from "../../components/dashboard/profilePartials/PaymentCards";
import { useGeneral } from "../../components/contexts/GeneralContext";

const SavedCardsPage = () => {
  const { discountCoupons } = useGeneral();
  return (
    <>
      {/* <FullScreenLoading /> */}
      <PageWrapper loading={false} className="bg-bg min-h-screen">
        <Header code={discountCoupons} />

        <BodyWrapper className="mb-0 xl:mb-0">
          <Wrapper goBack={true} component={<PaymentCards />}/>
        </BodyWrapper>
        <Footer />
      </PageWrapper>
    </>
  );
};

export default SavedCardsPage;
